import styles from './styles.module.scss';
import SearchHistoryHeader from './Header';
import SearchHistoryList from './List';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';

export default function SearchHistory() {
  const searchHistory = useSelector(
    (state: RootState) => state.casino.searchHistory,
  );

  if (searchHistory.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <SearchHistoryHeader />
      <SearchHistoryList />
    </div>
  );
}
